import { render, staticRenderFns } from "./EmployeeCreateEditModal.vue?vue&type=template&id=884fd1ae"
import script from "./EmployeeCreateEditModal.vue?vue&type=script&lang=js"
export * from "./EmployeeCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports